import { render, staticRenderFns } from "./labelHidden-editor.vue?vue&type=template&id=60a283e4&scoped=true&"
import script from "./labelHidden-editor.vue?vue&type=script&lang=js&"
export * from "./labelHidden-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a283e4",
  null
  
)

export default component.exports